module.exports = __webpack_public_path__ + "img/logo.29d04c59.png";